import { OnboardingDataLayerEvent } from "../types/onboardingDataLayerEvent"
import { OnboardingPostOctoshieldEvents } from "./onboardingPostOctoshieldEvents"

export const OnboardingPostQuoteEvents = [
    // QuoteEvents
    OnboardingDataLayerEvent.QuoteGenerated,
    OnboardingDataLayerEvent.QuoteValidated,
    // PersonalInfoEvents
    OnboardingDataLayerEvent.PersonalInfoRequest,
    OnboardingDataLayerEvent.PersonalInfoSubmitted,
    // PaymentInfoEvents
    OnboardingDataLayerEvent.PaymentInfoRequest,
    OnboardingDataLayerEvent.PaymentInfoSubmitted,
    // PostOctoshieldEvents
    ...OnboardingPostOctoshieldEvents,
] as const satisfies OnboardingDataLayerEvent[]
